module.exports = __webpack_public_path__ + "static/img/big-icon-3.cc1185e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/big-icon-3.png
// module id = 3Hpz
// module chunks = 85